import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Designation Service*/
const saveMoodRating = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.moodRating.saveMoodRating}`,
    method: "POST",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get Designation Service*/
const getAllMoodRating = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.moodRating.getAllMoodRating}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get find Daily Mood Rating Service*/
const findDailyMoodRating = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.moodRating.findDailyMoodRating}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get Designations By Department */
const findAllMoodRating = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.moodRating.findAllMoodRating}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Update Designation Service*/
const ratingPercent = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.moodRating.ratingPercent}`,
    method: "GET",
    params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Delete Designation Service*/
const dayWiseCoverage = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.moodRating.dayWiseCoverage}`,
    method: "GET",
    params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Update Designation Service*/
const keyFunctionData = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.moodRating.keyFunctionData}`,
    method: "GET",
    params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Delete Designation Service*/
const keyEmployeeData = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.moodRating.keyEmployeeData}`,
    method: "GET",
    params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

export default {
  saveMoodRating,
  getAllMoodRating,
  findDailyMoodRating,
  ratingPercent,
  dayWiseCoverage,
  findAllMoodRating,
  keyFunctionData,
  keyEmployeeData
}